import produce from 'immer';
import {
  MY_INFO_REQUEST,
  MY_NAME_CHANGE,
  MY_PASSWORD_CHANGE,
  MY_TWOFACTOR_REMOVE, SET_MY_INFO
} from '../../constants/setting/myInfoConstants';

const initialState = {
  myInfo: {},
};

/* eslint-disable default-case, no-param-reassign */
const myInfoReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case MY_INFO_REQUEST:
    case MY_PASSWORD_CHANGE:
    case MY_TWOFACTOR_REMOVE:
    case MY_NAME_CHANGE:
      break;
    case SET_MY_INFO:
      draft.myInfo = action.info;
      break;
  }
});

export default myInfoReducer;
